import { defineStore } from "pinia";
import { cloneDeep, merge } from "lodash";

const AlertType = {
  Success: "success",
  Error: "error",
  Warning: "warning",
  Info: "info",
};

const model = {
  message: "",
  visible: false,
  icon: "mdi-information",
  autoClose: true,
  top: false,
  theme: "default",
};

export const useAlert = defineStore("alert", {
  state: () => ({
    current: cloneDeep(model),
  }),
  actions: {
    setCurrent(params) {
      this.current = merge(this.current, params);
    },
    fire(params) {
      this.setCurrent({
        ...params,
        visible: true,
      });
      if (this.current.autoClose) {
        setTimeout(() => {
          this.reset();
        }, 4000);
      }
    },
    show() {
      this.current.visible = true;
    },
    hide() {
      this.current.visible = false;
    },
    reset() {
      this.current = cloneDeep(model);
    },
  },
});
